import { IMap } from 'typings/DeepIMap';
import * as Models from 'models';
import { ColumnRelation } from 'models';
import { isRegularRelation } from './isRegularRelation';

export function getParentRelation(
  relationId: string,
  relations: Models.RelationsMap | Models.LayeredRelationsMap,
): IMap<Models.RowRelation> | IMap<ColumnRelation> {
  return relations.find((relation) => {
    if (isRegularRelation(relation)) {
      return false;
    }

    return relation.get('relationIds').indexOf(relationId) !== -1;
  }) as Models.RowRelationMap | Models.ColumnRelationMap;
}
